__turbopack_context__.v({
  "Caption": "index-module__ASmtJa__Caption",
  "Checkbox": "index-module__ASmtJa__Checkbox",
  "CheckboxGroup": "index-module__ASmtJa__CheckboxGroup",
  "Indicator": "index-module__ASmtJa__Indicator",
  "Item": "index-module__ASmtJa__Item",
});
